/**
 * Created by sivanh on 12/06/2018.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var Dropdown = require("ui/dropdown/Dropdown");

    var template = require("manager-templates/schedule/scheduleEventItemView.tmpl");
    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var ScheduleShiftsListView = require("manager-views/schedule/ScheduleShiftsListView");

    var EVENT_TYPES_ORDER = [ScheduleUtilities.EVENT_TYPES.ALL_HOURS, ScheduleUtilities.EVENT_TYPES.INACTIVE, ScheduleUtilities.EVENT_TYPES.CUSTOM];

    var ScheduleEventItemView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleEventItemView = Marionette.CompositeView.extend({
            template: template,
            tagName:"li",
            className:"work-day-container",
            ui: {
                workDayWrapper: ".work-day-wrapper",
                activeIcon: ".active-icon",
                dayName: ".day-name-label",
                selectedType: ".working-hours-selected-type",
                scheduleShiftsListContainer: ".schedule-shifts-container"
            },
            uiComponents: {
                selectedType:{
                    type: Dropdown,
                    options:{
                        container: "view.ui.selectedType",
                        items: "view._getTypeOptions",
                        selectedOption: "view._getSelectedType",
                        testCollision: true,
                        collisionWithinSelector: ".le .manager-region .schedule-edit-view .view-container"
                    },
                    events:{
                        "change":"_onSelectedTypeOptionChange"
                    }
                },
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function () {
               this._onRender();
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _onRender: function () {
                this._updateDayNameLabel();

                var type = this.model.getType();
                this._renderScheduleShiftsListView(type);
            },

            _updateDayNameLabel: function () {
                var dayLanguinoKey = "LEManager.scheduleEditView.day." + this.model.id + ".label";
                var translatedNameLabel = LE.translator.translate(dayLanguinoKey);
                this.ui.dayName.text(translatedNameLabel);
            },

            _renderScheduleShiftsListView: function (type) {
                this.ui.workDayWrapper.toggleClass("inactive-type-mode", type === ScheduleUtilities.EVENT_TYPES.INACTIVE);

                if (type === ScheduleUtilities.EVENT_TYPES.CUSTOM) {
                    this._createScheduleShiftsListView();
                }
                else {
                    this._closeScheduleShiftsList();
                }
            },

            _createScheduleShiftsListView: function () {
                this._closeScheduleShiftsList();
                this.uiComponents.host$.createAndRender("scheduleShiftsList", {
                    type : ScheduleShiftsListView,
                    options : {
                        container: "view.ui.scheduleShiftsListContainer",
                        collection: this.model.getShiftsCollection(),
                        scheduleEventModel: this.model,
                        channel: this.channel
                    }
                });
            },

            _closeScheduleShiftsList: function () {
                if (this.uiComponents.scheduleShiftsList) {
                    this.uiComponents.scheduleShiftsList.close();
                }
            },

            _getTypeOptions: function () {
                var items = _.map(EVENT_TYPES_ORDER, function(type) {
                    return {
                        key: type,
                        value: LE.translator.translate("LEManager.scheduleEditView.shiftStatus." + type)
                    };
                });
                return new Dropdown.Collection(items);
            },

            _getSelectedType: function () {
                return this.model.getType();
            },

            _onSelectedTypeOptionChange: function (componentId, eventName, selectedObject) {
                var selectedKey = selectedObject.selectedKey;
                this.channel.trigger("ScheduleEventItem:change:type", this.model, selectedKey);
                this._renderScheduleShiftsListView(selectedKey);
            }


        });
    }

    LE.module("LEManager", moduleDefinition);

    return ScheduleEventItemView;
});

